module.exports = __webpack_public_path__ + "img/3.37bbb30c.png";